<template>
  <div class="import-modals">
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de representante"
      message="Tem certeza que deseja excluir este representante?"
    />
    <representative-edit-modal />
  </div>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import RepresentativeActions from './RepresentativeActions';
import RepresentativeEditModal from './modal/RepresentativeEditModal.vue';

export default {
  name: 'representatives-imports',
  mixins: [RepresentativeActions],
  components: {
    ConfirmationModal,
    RepresentativeEditModal,
  },
};
</script>
